var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "signin-case" },
    [
      _c("div", { staticClass: "title", on: { click: _vm.openDialog } }, [
        _c("div", { staticClass: "title-text" }, [_vm._v("签到情况")]),
        _c("div", { staticClass: "title-nexticon iconfont icon-icon_more" }),
      ]),
      _c("div", { staticClass: "types" }, [
        _c("div", { staticClass: "type actual" }, [
          _c("p", { staticClass: "type-name" }, [_vm._v("实到人数")]),
          _c("p", { staticClass: "type-num" }, [
            _vm._v(_vm._s(_vm.courseList.realNum || 0)),
          ]),
        ]),
        _c("div", { staticClass: "type shoud" }, [
          _c("p", { staticClass: "type-name" }, [_vm._v("应到人数")]),
          _c("p", { staticClass: "type-num" }, [
            _vm._v(_vm._s(_vm.courseList.shouldNum || 0)),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "list" },
        _vm._l(_vm.courseList.signMessageList, function (item, index) {
          return _c(
            "div",
            { key: index, staticClass: "list-item" },
            [
              _c("van-image", {
                staticClass: "list-headerimg",
                attrs: {
                  "lazy-load": "",
                  src: _vm._f("imgFormat")(item.photo),
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "loading",
                      fn: function () {
                        return [
                          _c("van-loading", {
                            attrs: { type: "spinner", size: "20" },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "error",
                      fn: function () {
                        return [
                          _c("img", {
                            staticClass: "list-errorimg",
                            staticStyle: { width: "100%", height: "100%" },
                            attrs: { src: _vm.defaultImg },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
              }),
              _c("div", { staticClass: "name" }, [
                _vm._v(_vm._s(item.name || "")),
              ]),
              _c("div", { staticClass: "time" }, [
                _vm._v(
                  _vm._s(_vm.dsf.date.format(item.signInTime, "hh:ii:ss"))
                ),
              ]),
            ],
            1
          )
        }),
        0
      ),
      _c(
        "van-dialog",
        {
          attrs: {
            width: "80%",
            title: "点击任意处关闭",
            "close-on-click-overlay": "",
            "show-confirm-button": false,
          },
          model: {
            value: _vm.DetailsDialog,
            callback: function ($$v) {
              _vm.DetailsDialog = $$v
            },
            expression: "DetailsDialog",
          },
        },
        [
          _c("SigninDetails", {
            attrs: { stuList: _vm.stuList, classNameSet: _vm.classNameSet },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }